import styled from "styled-components/macro";
import { Grid } from "@mui/material";

export const StyledGrid = styled(Grid)`
  display: flex;
  justify-content: center;
`;
